import { render, staticRenderFns } from "./audioplay.vue?vue&type=template&id=45209f94&scoped=true&"
import script from "./audioplay.vue?vue&type=script&lang=js&"
export * from "./audioplay.vue?vue&type=script&lang=js&"
import style0 from "./audioplay.vue?vue&type=style&index=0&id=45209f94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45209f94",
  null
  
)

export default component.exports